import detect from './detect.svg';
import respond from './response.svg';
import verify from './verification.svg';

const phaseIcons = {
	detect,
	verify,
	respond
};

export default phaseIcons;
